import { render, staticRenderFns } from "./alert-box.vue?vue&type=template&id=4f91a25e&"
import script from "./alert-box.vue?vue&type=script&lang=js&"
export * from "./alert-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports